import { IconActionsMoreHoriz, Text } from "@twinkltech/web-ui";
import { useId } from "react";

import { TagList } from "@/components/TagList/TagList";

import { TableResource } from "@/states/unitTableReducer/unitTableReducer";

import { getCohortSlugTranslations } from "../TagList/utils/getCohortSlugTranslations/getCohortSlugTranslations";
import { getThreadSlugTranslations } from "../TagList/utils/getThreadSlugTranslations/getThreadSlugTranslations";

export const NewDrawerCard = ({
  className,
  isDragging,
  resource,
  ...props
}: {
  isDragging?: boolean;
  resource: TableResource;
} & Omit<React.ComponentProps<"div">, "resource">) => {
  const titleId = useId();

  return (
    <div
      aria-labelledby={titleId}
      className={[
        "min-h-[88px] rounded-[8px]",
        isDragging &&
          "card-dragging relative bg-neutral-150 before:content-[''] before:absolute before:bg-blue-500 before:rounded-lg before:w-1 before:left-0 before:top-[0.5rem] before:bottom-0 before:h-[calc(100%-1rem)] flex justify-between w-[360px] rounded-[8px] px-5 py-3 shadow-[0_1px_2px_0px_rgba(0,0,0,0.1)] border-2 border-blue-500",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      <div
        aria-label="unit card information"
        className="flex flex-col gap-3"
        role="group"
      >
        <Text as="h3" id={titleId} variant="sm-medium">
          {resource.name}
        </Text>
        <div className="flex gap-1">
          <TagList
            maxCount={1}
            tags={
              new Set([
                ...getCohortSlugTranslations(resource?.keyStagesSlug),
                ...getThreadSlugTranslations(resource?.threadSlugs),
              ])
            }
            variant="dark"
          />
        </div>
      </div>

      {/*
        Note: Some pokey-jiggery going on here. The icon is in the card and the button is overlayed on it. It's not great
        but we need the cross to be visible when dragging, and we can't render the action menu in the card (absolute positioning)
        because it would not be clickable due to the on-click dragging behavior.
      */}

      <div className="flex flex-col justify-center rounded" role="presentation">
        <IconActionsMoreHoriz aria-hidden="true" />
      </div>
    </div>
  );
};
